import { render, staticRenderFns } from "./DiscountPrepositionsPhone.vue?vue&type=template&id=d0a4d22a&"
import script from "./DiscountPrepositionsPhone.vue?vue&type=script&lang=js&"
export * from "./DiscountPrepositionsPhone.vue?vue&type=script&lang=js&"
import style0 from "./DiscountPrepositionsPhone.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Ftips-phone&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports